<header class="header">
  <div class="header-background" aria-hidden="true"></div>

  <div class="header-inner">
    <div class="header-left">
      <picture class="header-logo-wrapper">
        <source srcset="./assets/images/logo_advisors_weiß.webp" type="image/webp" />
        <img
          src="./assets/images/logo_advisors_weiß.png"
          alt="msg advisors"
          class="header-logo"
          (click)="navigateToHome()"
          (keyup.enter)="navigateToHome()"
          tabindex="0"
        />
      </picture>
    </div>

    <nav class="nav-links" aria-label="Page sections">
      <button type="button" class="nav-link" (click)="navigateToSection('how-it-works')">
        {{ 'header.howItWorks' | translate }}
      </button>
      <button type="button" class="nav-link" (click)="navigateToSection('pricing')">
        {{ 'header.pricing' | translate }}
      </button>
      <button type="button" class="nav-link" (click)="navigateToContact()">
        {{ 'header.contact' | translate }}
      </button>
    </nav>

    <nav class="header-actions" aria-label="Site actions">
      <p-button
        styleClass="icon-btn header-mobile-toggle"
        ariaLabel="menu"
        (click)="mobileMenu.toggle($event)"
        [rounded]="true"
        [text]="true"
      >
        <i class="pi pi-bars" aria-hidden="true"></i>
      </p-button>
      <p-button
        styleClass="icon-btn"
        ariaLabel="language"
        (click)="languageMenu.toggle($event)"
        [rounded]="true"
        [text]="true"
        tooltipPosition="bottom"
        [pTooltip]="'header.languageSwitcher' | translate"
      >
        <i class="pi pi-language" aria-hidden="true"></i>
      </p-button>
      <p-button
        styleClass="icon-btn"
        ariaLabel="dashboard"
        (click)="openOsint()"
        [rounded]="true"
        [text]="true"
        tooltipPosition="bottom"
        [pTooltip]="'header.osintConsole' | translate"
      >
        <i class="pi pi-objects-column" aria-hidden="true"></i>
      </p-button>
    </nav>
  </div>
</header>

<p-tieredMenu #languageMenu [popup]="true" [model]="languageItems()" styleClass="language-menu" appendTo="body">
  <ng-template #item let-item>
    <div class="language-item">
      <img [alt]="item.label" [src]="'assets/flags/' + item.code + '.svg'" class="flag" />
      <span>{{ item.label }}</span>
      @if (item.active) {
        <i class="pi pi-check" aria-hidden="true"></i>
      }
    </div>
  </ng-template>
</p-tieredMenu>

<p-tieredMenu #mobileMenu [popup]="true" [model]="mobileMenuItems()" styleClass="mobile-nav-menu" appendTo="body" />
